'use client';

import { useContext } from 'react';

import { useDisconnect } from 'wagmi';

import { GlobalDataContext } from '@/providers/GlobalDataProvider';
import { signOutAction } from '@/server/actions/auth/signOut.action';

export function useSignOut() {
  const { updateGlobalData } = useContext(GlobalDataContext);
  const { disconnectAsync } = useDisconnect();

  return async function signOut() {
    try {
      await signOutAction();
      await disconnectAsync();

      updateGlobalData({
        user: null,
        avatars: null,
        notificationPreferences: null,
        notificationUnreadCounts: null,
        isWelcomeOpen: false,
        isAccountOpen: false,
        isWalletConnectOpen: false,
        accountSheetInitialView: null
      });

      console.log('Sign out successful');
    } catch (error) {
      console.error('Sign out failed:', error);
      throw error;
    }
  };
}
